import React from 'react';

import StepTimer from 'notebook/protocols/viewer/StepTimer';
import {ElementKeyboardEvent} from 'util/Types';

import {Step} from '../StepConstants';

interface TimerEditableWrapperProps {
  locked?: boolean;
  step: Step;
  index: number;
  visible?: boolean;
  isMultiEditable: boolean;
  deleteHandler: () => void;
  updateTimeHandler: (time: number) => void;
  setSelection: (selection: SelectionRestoreData) => void;
  storeState: () => void;
  restoreState: (
    e: ElementKeyboardEvent,
    selection: {
      selection: SelectionRestoreData;
    }
  ) => boolean;
}

// eslint-disable-next-line react/prefer-stateless-function
export default class TimerEditableWrapper extends React.Component<TimerEditableWrapperProps> {
  override render(): JSX.Element {
    return (
      <div className="timer-editable-wrapper">
        {!this.props.locked ? (
          <a className="del-timer-btn big-btn del-btn round-btn" onClick={this.props.deleteHandler}>
            {'\u00D7'}
          </a>
        ) : undefined}
        <StepTimer
          inline={true}
          originalMS={this.props.step?.timer?.milliseconds!}
          allowEdits={!this.props.locked}
          editHelpers={{
            cid: this.props.step.cid,
            updateTimeHandler: this.props.updateTimeHandler,
            setSelection: this.props.setSelection,
            storeState: this.props.storeState,
            restoreState: this.props.restoreState,
          }}
        />
      </div>
    );
  }
}
